import * as $ from 'jquery';
import * as webauthn from "p360wsc-js/webauthn";

export function login(elements, options) {
    let userHasWebAuthnDevicesAvailable;
    let authenticationMethod = () => (
            userHasWebAuthnDevicesAvailable &&
            webauthn.getWebAuthnRememberedUsername() &&
            webauthn.webAuthnSupported()
        ) ? 'webAuthn' : 'password';
    (function() {
        let timeout;
        let xhr;
        if (webauthn.getWebAuthnRememberedUsername()) {
            elements.usernameInput.val(webauthn.getWebAuthnRememberedUsername());
        }
        elements.usernameInput.on('input', ({currentTarget}) => {
            if (!currentTarget.value) {
                return;
            }
            userHasWebAuthnDevicesAvailable = undefined;
            xhr && xhr.abort && xhr.abort();
            timeout && clearTimeout(timeout);
            timeout = setTimeout(() => {
                xhr = $.get({
                    url: options.webAuthnCheckUrl.replace('__username__', currentTarget.value)
                }).then((response) => {
                    userHasWebAuthnDevicesAvailable = !!response.status;
                }).catch(() => {
                    userHasWebAuthnDevicesAvailable = false;
                });
            }, 700);
        });
    })();
    const onUsernameChange = ({currentTarget}) => {
        if (currentTarget.value && elements.proceedButton.hasClass('disabled')) {
            elements.proceedButton.removeClass('disabled').prop('disabled', false);
        }
        if (!currentTarget.value && !elements.proceedButton.hasClass('disabled')) {
            elements.proceedButton.addClass('disabled').prop('disabled', true);
        }
    };
    onUsernameChange({currentTarget: elements.usernameInput[0]});
    elements.usernameInput.on('input', onUsernameChange);
    elements.proceedButton.on('click', () => {
        if (!elements.usernameInput.val()) {
            return;
        }
        let nextStep = $.Deferred();
        nextStep.then((authenticationMethod) => {
            if (authenticationMethod === 'webAuthn') {
                webauthn.login(
                    { username: elements.usernameInput.val() },
                    (response) => {
                        console.log(response);
                        if (response.location) {
                            webauthn.markDeviceAsWebAuthnRemembered(elements.usernameInput.val());
                            window.location = response.location;
                        }
                    },
                    (response) => console.log(response)
                )($('[data-webauthn-login-options]').data('webauthn-login-options'));
            } else {
                console.log('Password auth method only available');
            }
        });
        if (userHasWebAuthnDevicesAvailable !== undefined) {
            elements.steps.username.hide();
            elements.steps[authenticationMethod()].show();
            nextStep.resolve(authenticationMethod());
        } else {
            elements.form.addClass('loading');
            $.get({
                url: options.webAuthnCheckUrl.replace('__username__', elements.usernameInput.val())
            }).then((response) => {
                userHasWebAuthnDevicesAvailable = !!response.status;
                elements.form.removeClass('loading');
                elements.steps.username.hide();
                elements.steps[authenticationMethod()].show();
                nextStep.resolve(authenticationMethod());
            });
        }
    });
    elements.form.on('submit', (e) => {
        if (elements.steps.password.isHidden()) {
            e.preventDefault();
            elements.steps.password.show();
            elements.steps.webAuthn.hide();
            elements.steps.username.hide();
            return false;
        }
    });
    elements.backButton.on('click', () => {
        elements.steps.password.hide();
        elements.steps.webAuthn.hide();
        elements.steps.username.show();
    });
    elements.skipButton.on('click', () => {
        elements.steps.webAuthn.hide();
        elements.steps.password.show();
    });
}
